module.exports = __webpack_public_path__ + "images/icon-award-ribbon.9acfb0.svg";